import {AbilityType} from "../../actions/ability/Type";

const initialState = {
    ability: null
}
const abilityReducer = (state = initialState, action) => {

    switch (action.type) {
        case AbilityType.ON_CHANGE_ABILITY:
            return {
                ...state,
                ability: action.payload
            }
        default:
            return state;
    }
}

export default abilityReducer

